export function navigatorGetCurrentPosition(fn) {
  // 用浏览器定位
  // window.navigator.geolocation.getCurrentPosition(function(position) {
  //   let x = position.coords.longitude;
  //   let y = position.coords.latitude;
  //   let gpsPoint = new BMap.Point(x, y);
  //   let convertor = new BMap.Convertor();
  //   convertor.translate([gpsPoint], 1, 5, function(convRst) {
  //     if (convRst.status === 0) {
  //       if(fn) fn(convRst.points[0]);
  //     }
  //   });
  // });
  // 百度地图定位
  const geolocation = new BMap.Geolocation();
  geolocation.getCurrentPosition(
    function(r) {
      if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        if(fn) fn(r.point);
      } else {
        window.console.log("failed" + this.getStatus());
      }
    },
    { enableHighAccuracy: true }
  );
}

export function isPoneAvailable(str) {
  var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

export function add(a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return e = Math.pow(10, Math.max(c, d)), (mul(a, e) + mul(b, e)) / e;
}

export function sub(a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return e = Math.pow(10, Math.max(c, d)), (mul(a, e) - mul(b, e)) / e;
}

export function mul(a, b) {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split(".")[1].length;
  } catch (f) { }
  try {
    c += e.split(".")[1].length;
  } catch (f) { }
  return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}

export function div(a, b) {
  var c, d, e = 0,
    f = 0;
  try {
    e = a.toString().split(".")[1].length;
  } catch (g) { }
  try {
    f = b.toString().split(".")[1].length;
  } catch (g) { }
  return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), mul(c / d, Math.pow(10, f - e));
}